import axios from "axios";
import { appConfig } from "../../config";
import { urlFilter } from "../../utilities";

async function httpGet<T = any>(url: string): Promise<T> {
  const baseUrl: string = appConfig.chatUrl || ""
  const { data, status } = await axios.get<T>(urlFilter(baseUrl, url),
    {
      headers: {
        Accept: 'application/json',
      },
      withCredentials: true
    },
  )

  return data;
}

export {httpGet}